import {
  DEFAULT_CONTAINER_CLASSNAME,
  DEFAULT_CONTENT_CLASSNAME,
} from '../constant';
import {PartialFrameElements} from '../type/PartialFrameElements.interface';

export function makePartialFrameElements(): PartialFrameElements {
  const shadowHostElement = document.createElement('div');

  const shadowRoot = shadowHostElement.attachShadow({mode: 'open'});

  const containerElement = document.createElement('div');
  containerElement.classList.add(DEFAULT_CONTAINER_CLASSNAME);
  shadowRoot.appendChild(containerElement);

  const defaultStyleElement = document.createElement('style');
  containerElement.appendChild(defaultStyleElement);

  const settingStyleElement = document.createElement('style');
  containerElement.appendChild(settingStyleElement);

  const styleElement = document.createElement('style');
  containerElement.appendChild(styleElement);

  const contentElement = document.createElement('div');
  contentElement.classList.add(DEFAULT_CONTENT_CLASSNAME);
  containerElement.appendChild(contentElement);

  return {
    shadowHostElement,
    shadowRoot,
    containerElement,
    defaultStyleElement,
    styleElement,
    settingStyleElement,
    contentElement,
  };
}
